module.exports = __webpack_public_path__ + "static/img/search.afeef1f9.png";